import React from "react";
import { Navigate } from "react-router-dom";
import { authenticatedRequest } from "../../../services/api/student/api.service";
import chatService from "../../../services/chat/chat.service";
import { disconnectWebSocket } from "../../../lib/websocket";

class Logout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectTo: null,
    };
  }
  logout = async () => {
    await chatService.updateOnlineStatus(false);
    await disconnectWebSocket();

    localStorage.clear();
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    await authenticatedRequest("/logout", "POST");
  };

  render() {
    this.logout().then(() => {
      this.setState({ redirectTo: true });
    });
    return this.state.redirectTo ? <Navigate to="/new/aluno" /> : <></>;
  }
}

export default Logout;
